import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  APP_DATE_FORMAT,
  CommonUtility,
  DataService,
  DateUtility, INVALID_EMAIL,
  PersonInformation,
  ServerConstantsService,
  WpPerson,
  ClientInformation, EMAIL_REGEXP
} from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ReferenceTableService } from '../reference-table.service';
import { Observable } from 'rxjs/Observable';
import { CanComponentDeactivate, CanDeactivateGuardService } from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-person-information',
  templateUrl: './person-information.component.html',
  styleUrls: ['./person-information.component.scss'],
})
export class PersonInformationComponent implements OnInit, CanComponentDeactivate {

  personInformation: PersonInformation;
  wpPerson: WpPerson;
  referralId: string;
  wpPersonId: string;

  genderCds: Array<any>;
  genderMap: Map<string, string>;
  languagesCds: Array<any>;
  optTextMessage: Array<any>;
  languagesMap: Map<string, string>;
  optTextMessageMap: Map<string, string>;
  contactMethodCds: Array<any>;
  contactMethodMap: Map<string, string>;
  userActionNotificationsMap: any;

  errorMessage: string;
  serverConstants: any;
  sharedData: any;
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  origPrimaryLanguage: any = '';
  contactMethod: any;
  email: any;
  primaryLanguage: any;
  secondaryLanguage: any;
  ssn = '';
  errorEmailField: string = null;
  isUniverse = false;
  clientInfo: ClientInformation;
  ssnValue;
  isChangeDetected: boolean;
  emciId:String = null;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('emailField') emailField: ElementRef;
  @ViewChild('personInfo') personInfo: ElementRef;


  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService,
    private modalService: NgbModal,
    private datePipe:DatePipe
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.data.getValueFromSharedDataMap('GENDER') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    window.addEventListener('beforeunload', function (e) {
      const confirmationMessage = '\o/';
      e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
      return confirmationMessage;              // Gecko, WebKit, Chrome <34
    });
    this.dataService.globalAccess = true;
    this.sharedData = this.dataService.getSharedDataObject();
    this.ssnValue = this.sharedData.get('SSN_SEARCH');
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');

    this.genderCds = this.data.getValueFromSharedDataMap('GENDER');
    this.languagesCds = this.data.getValueFromSharedDataMap('LANGUAGES');
    this.optTextMessage = this.data.getValueFromSharedDataMap('OPT-TEXT-MSG-ALERTS');
    this.contactMethodCds = this.data.getValueFromSharedDataMap('CONTACTMETHODS');

    this.genderMap = this.commonUtil.createMapFromList(this.genderCds);
    this.languagesMap = this.commonUtil.createMapFromList(this.languagesCds);
    this.optTextMessageMap = this.commonUtil.createMapFromList(this.optTextMessage);

    this.contactMethodMap = this.commonUtil.createMapFromList(this.contactMethodCds);
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(
      this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.wpPerson = new WpPerson();
    this.clientInfo = new ClientInformation();
    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadFromAries(this.sharedData.get('personProvider').emciId) : this.load();



  }


  loadFromAries(emciId) {

    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/Aries/clientInfo/' + emciId + "/null").subscribe(
      (data: Array<Object>) => {                                   
        console.log(this.dataService.getSharedDataObject());
        if (data !== null && data !== undefined && data.length > 0) {

        console.log('Message: ' + data[0]["message"]);
        let messageData = data[0]["message"];
        console.log('Code: ' + messageData["code"]);
        console.log('Desc: ' + messageData["description"]);

        if(data[0]["message"] !== undefined) {
          let message = data[0]["message"];
          if(message !== undefined) {
            if(messageData["code"] === 'SWARIE-C-007')  {
              this.notificationService.error('Case Closed', 'SNAP Case is closed');
            } else if(messageData["code"] === 'SWARIE-C-005' || messageData["code"] === 'SWARIE-C-006')  {
              this.notificationService.error('Case Pending',  messageData["description"]);
            }
          }
        } 
        
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'PA');
          this.clientInfo.RESIDENTIAL_ADDR_LINE1=address["addrLine1"];
          this.clientInfo.RESIDENTIAL_ADDR_LINE2=address["addrLine2"];
          this.clientInfo.RESIDENTIAL_ADDR_CITY=address["addrCity"];
          this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"];
          this.clientInfo.RESIDENTIAL_ADDR_STATE=address["addrStateCd"];
          this.clientInfo.RESIDENTIAL_ADDR_ZIP=address["addrZip5"];
        }
        if(data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA') !== undefined){
          let address = data[0]["address"].find(obj => obj['addrTypeCd'] == 'MA');
          //(this.clientInfo.RESIDENTIAL_COUNTY === null && address["addrCountyCd"] !== null) ? this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"] : this.clientInfo.RESIDENTIAL_COUNTY=this.clientInfo.RESIDENTIAL_COUNTY;
          //this.clientInfo.RESIDENTIAL_COUNTY=address["addrCountyCd"];
          this.clientInfo.MAILING_ADDR_LINE1=address["addrLine1"];
          this.clientInfo.MAILING_ADDR_LINE2=address["addrLine2"];
          this.clientInfo.MAILING_ADDR_CITY=address["addrCity"];
          this.clientInfo.MAILING_ADDR_STATE=address["addrStateCd"];
          this.clientInfo.MAILING_ADDR_ZIP=address["addrZip5"];
        }
          this.clientInfo.CLIENTID = data[0]["indvId"];
          let dobDt = new Date(data[0]["dobDt"]);
          this.clientInfo.DOB_DT= this.datePipe.transform(dobDt, 'MM/dd/yyyy');
          this.clientInfo.FIRST_NAME = data[0]["firstName"];
          this.clientInfo.LAST_NAME = data[0]["lastName"];
          this.clientInfo.MESSAGE_PHONE = data[0]["primaryPhnNum"];
          this.clientInfo.WORK_PHONE = data[0]["workPhnNum"];
          this.clientInfo.RESIDENTIAL_PHONE = data[0]["altPhnNum"];
          this.clientInfo.PRIMARY_LANGUAGE = data[0]["primaryLang"];
          this.clientInfo.EMCI_ID = data[0]["indvId"];
          if(data[0]["genderCd"] === 'M'){
            this.clientInfo.GENDER_CD = "Male";
          }
          else{
            this.clientInfo.GENDER_CD = "Female";
          }
          

          this.clientInfo.DOB_DT = this.dateUtil.convertFormattedDateFromServer(this.dateUtil.formatDate(this.clientInfo.DOB_DT));
          this.dataService.addValueToSharedDataMap('UniverseClientInfo', this.clientInfo);
          this.ssn = 'XXX-XX-' + this.ssnValue.substring(5);
          if(this.isUniverse){
            this.wpPerson = new WpPerson();
          }
          else{
            this.wpPerson = new WpPerson();
            this.wpPerson = this.dataService.getSharedDataObject().get('wpPerson');
            this.wpPerson.ssn = this.ssnValue;
          }
          this.wpPerson.firstName = this.clientInfo.FIRST_NAME;
          this.wpPerson.lastName = this.clientInfo.LAST_NAME;
          this.wpPerson.dobDt = this.clientInfo.DOB_DT;
          this.emciId = this.clientInfo.EMCI_ID

        /*} else if(data.hasOwnProperty('ResponseMetaData')) {
          this.notificationService.error('Case Closed', 'SNAP Case is closed');  */       
        } else {
          this.notificationService.error('Universe Search', 'Unable to retrieve data from eligibility system.');
        }
      },
      response => {
        this.notificationService.error('Universe Search', 'Unable to retrieve data from eligibility system.');
      },
      () => {
        if ((this.isUniverse === undefined || this.isUniverse === false) &&  this.clientInfo.DOB_DT === undefined) {
          this.personInformation = new PersonInformation(parseInt(this.wpPersonId, 10), null);
          this.loadPersonDtails();
        }
      });


  }

  load() {
console.log('this.isUniverse ===== ' +this.isUniverse);
    this.http.get<ClientInformation[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetDemographic/' + this.ssnValue).subscribe(
      (data: ClientInformation[]) => {
        console.log(this.dataService.getSharedDataObject());
        if (data !== null && data !== undefined && data.length > 0) {
          this.clientInfo = data[0];

          if(this.clientInfo.ERROR_CODE != null && this.clientInfo.ERROR_CODE != undefined) {
            if(this.clientInfo.ERROR_CODE === '0001') {
            this.notificationService.error('Universe Search', 'Client does not exist in the eligibility system.');
            } else if(this.clientInfo.ERROR_CODE === 'SWARIE-C-007') {
              this.notificationService.error('Case Closed', 'SNAP Case is closed');

              if(this.isUniverse){
                this.dataService.addValueToSharedDataMap('isCaseClosed', true);
              } else {
                this.dataService.addValueToSharedDataMap('isCaseClosed', false);
              }
            } else if(this.clientInfo.ERROR_CODE === 'SWARIE-C-005' || this.clientInfo.ERROR_CODE === 'SWARIE-C-006') {

              if(this.isUniverse){
                this.dataService.addValueToSharedDataMap('isCasePending', true);
              } else {
                this.dataService.addValueToSharedDataMap('isCasePending', false);
              }
              this.notificationService.error('Case Pending', this.clientInfo.ERROR_MESSAGE);
            }
          } else {

          this.clientInfo.DOB_DT = this.dateUtil.convertFormattedDateFromServer(this.dateUtil.formatDate(this.clientInfo.DOB_DT));
          this.dataService.addValueToSharedDataMap('UniverseClientInfo', this.clientInfo);
          this.ssn = 'XXX-XX-' + this.ssnValue.substring(5);
          this.dataService.addValueToSharedDataMap('isCaseClosed', false);
          this.dataService.addValueToSharedDataMap('isCasePending', false);
          if(this.isUniverse){
            this.wpPerson = new WpPerson();            
          }
          else{
            this.wpPerson = new WpPerson();
            this.wpPerson = this.dataService.getSharedDataObject().get('wpPerson');
            this.wpPerson.ssn = this.ssnValue;
          }
          this.wpPerson.firstName = this.clientInfo.FIRST_NAME;
          this.wpPerson.lastName = this.clientInfo.LAST_NAME;
          this.wpPerson.dobDt = this.clientInfo.DOB_DT;        
          this.emciId = this.clientInfo.EMCI_ID

          }

        } else {
          this.notificationService.error('Universe Search', 'Unable to retrieve data from eligibility system.');
          
        }
      },
      response => {
        this.notificationService.error('Universe Search', this.userActionNotificationsMap.ERROR);
      },
      () => {
        if ((this.isUniverse === undefined || this.isUniverse === false) &&  this.clientInfo.DOB_DT === undefined) {
          this.personInformation = new PersonInformation(parseInt(this.wpPersonId, 10), null);
          this.loadPersonDtails();
        }
      });


  }


  loadPersonDtails() {
    this.dataService.addValueToSharedDataMap('wpPersonId', this.personInformation.personId);

    this.http.post<PersonInformation>(this.serverConstants.COMMON_SERVER_API_URL +
      '/personsummary/personInformation', this.personInformation)
      .subscribe(
        (res: PersonInformation) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Client', this.userActionNotificationsMap.ERROR + ' Could not retrieve the client information.');
          } else {
            this.personInformation = res;
            this.wpPerson = this.personInformation.wpPerson;
            this.wpPerson.dobDt = this.dateUtil.convertFormattedDateFromServer(this.wpPerson.dobDt);
            this.ssn = 'XXX-XX-' + this.ssnValue.substring(5);

          }
        },
        (response) => {

          this.notificationService.error('Client', this.userActionNotificationsMap.ERROR + ' Could not reach the server.');
        },
        () => {
        });
  }

  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }


  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  }

  save() {
    if (!this.validateEmail()) {
      this.notificationService.warn('Staff Management', INVALID_EMAIL);
      return;
    }

    this.isChangeDetected = false;
    this.wpPerson.dobDt = this.dateUtil.convertFormattedDateForServer(this.wpPerson.dobDt);

    if (this.wpPerson.textMessageSw === 'N' || this.wpPerson.textMessageSw === undefined || this.wpPerson.textMessageSw === null) {
      this.wpPerson.preferredPhone = null;
    }

    this.http.post<WpPerson>(this.serverConstants.COMMON_SERVER_API_URL + '/persondata/save', this.wpPerson)
      .subscribe(
        (res: any) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Client', this.userActionNotificationsMap.ERROR + ' Could not save the client information.');
            setTimeout(() => this.fileInput.nativeElement.focus(), 0);
            this.fileInput.nativeElement.click();
          } else {
            this.wpPerson = res;
            this.wpPerson.dobDt = this.dateUtil.convertFormattedDateFromServer(this.wpPerson.dobDt);
            this.notificationService.success('Client', this.userActionNotificationsMap.UPDATE);
            setTimeout(() => this.headerText.nativeElement.focus(), 0);
            this.headerText.nativeElement.click();
          }
        },
        (response) => {
          this.notificationService.error('Client', this.userActionNotificationsMap.ERROR + ' Could not reach the server.');
          setTimeout(() => this.fileInput.nativeElement.focus(), 0);
          this.fileInput.nativeElement.click();
        },
        () => {
        });

  }

  validateEmail() {
    const regExp = EMAIL_REGEXP;

    if (this.wpPerson.email !== null && this.wpPerson.email !== undefined && this.wpPerson.email !== "") {
      if (!regExp.test(String(this.wpPerson.email).toLowerCase())) {
        this.errorEmailField = INVALID_EMAIL;
        return false;
      }
    } else {
      return true;
    }

    this.errorEmailField = null;
    return true;
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  focusPersonInfo(e: KeyboardEvent) {
    if (e.keyCode === 9) {
      setTimeout(() => this.personInfo.nativeElement.focus(), 0);
    }
  }
}








// WEBPACK FOOTER //
// ./src/app/person-information/person-information.component.ts